import type { IBuild } from '@/entities/build.entity';

export function formatPanelBuildLabel(build: IBuild): string {
	const name = build.appName ?? build.id;
	const date = new Date(build.createdAt).toLocaleDateString('ru-RU');
	return `${name} · ${date}`;
}

export function resolveBuildLabel(buildId: string, allBuilds: IBuild[]): string {
	const build = allBuilds.find(b => b.id === buildId);
	return build ? formatPanelBuildLabel(build) : buildId;
}
